//* ------------------------------------*\
//    $CLASS NAMES - for class names
//      not CSS selectors
//* ------------------------------------*/

const CLASS_NAMES = {
  ABOVE_BOTTOM: 'above-bottom',
  ABOVE_HALFWAY: 'above-halfway',
  ABOVE_VIEWPORT: 'above-viewport',
  ACTIVE: 'active',
  BELOW_BOTTOM: 'below-bottom',
  BELOW_HALFWAY: 'below-halfway',
  BELOW_VIEWPORT: 'below-viewport',
  BLINK: 'blink',
  CLICK: 'click',
  CLOSED: 'closed',
  EXPANDED: 'expanded',
  ERROR: 'error',
  EVENTSLANDING_BOTTOM: 'eventslanding__bottom',
  EVENTSLANDING_BOTTOM_SHOW: 'eventslanding__bottom--show',
  EVENTSLANDING_BOTTOM_LOCK: 'eventslanding__bottom--lock',
  FINAL: 'final',
  HEADER: 'header',
  HIDE: 'hide',
  HIDDEN: 'hidden',
  HOVER: 'hover',
  IN_VIEWPORT: 'in-viewport',
  LOADING: 'loading',
  MENU_ITEM_HAS_CHILDREN: 'menu-item-has-children',
  MOBILIZE_EVENT: 'mobilizeevent',
  NAV_OPEN: 'nav-open',
  OPEN: 'open',
  PLAYING: 'playing',
  RESOURCE: 'resourcessection__resource',
  SHOW: 'show',
  STICKY_HEADER_DARK: 'sticky-header-dark',
  SUB_MENU: 'sub-menu',
  SUB_MENU_OPEN: 'sub-menu-open',
  USER_TABBING: 'user-is-tabbing',
  VIDEO_EMBED: 'video__embed',
  MODAL: 'modal',
  NAV_BURGER: 'nav__burger'
};

export default CLASS_NAMES;
